import type { FormInstance, FormItemProps } from 'antd';

export interface FormItem {
  formItem: FormItemProps;
  item: React.ReactNode;
}

interface EditProfileFormModalProps {
  show: boolean;
  setShow: (show: boolean) => void;
  title?: string | null;
  form: FormInstance;
  formItems: FormItem[];
  onFinish?: (values: any) => void;
  onReset?: () => void;
  onFinishText?: string | null;
  onResetText?: string | null;
  onCancel?: () => void;
  onCancelText?: string | null;
}

export default function EditProfileFormModal({
  show,
  setShow,
  title = null,
  form,
  formItems,
  onFinish,
  onReset,
  onFinishText,
  onResetText,
  onCancel,
  onCancelText,
}: EditProfileFormModalProps) {
  return (
    <Modal
      open={show}
      title={title}
      onCancel={() => setShow(false)}
      footer={null}
      width={390}
      centered
      styles={{
        content: {
          padding: '16px',
          borderRadius: '12px',
        },
        body: {
          padding: '10px 0 0',
        },
      }}
    >
      <Form
        labelCol={{ span: 0 }}
        wrapperCol={{ span: 24 }}
        form={form}
        name={`form-${title}-${Math.random()}`}
        onFinish={onFinish}
      >
        {formItems.map((item) => (
          <Form.Item key={item.formItem.name} {...item.formItem}>
            {item.item}
          </Form.Item>
        ))}
        <Flex gap={10} justify="end">
          {onResetText && (
            <Button
              htmlType="button"
              onClick={() => {
                onReset?.();
              }}
            >
              {onResetText}
            </Button>
          )}
          {onCancelText && (
            <Button
              htmlType="button"
              onClick={() => {
                onCancel?.();
              }}
            >
              {onCancelText}
            </Button>
          )}
          {onFinishText && (
            <Button type="primary" htmlType="submit">
              {onFinishText}
            </Button>
          )}
        </Flex>
      </Form>
    </Modal>
  );
}
